import {Component, OnInit} from "@angular/core";
import {MessageService} from "../../../shared/services/message.service";
import {Message, MessageType} from "../../../shared/models/message";

@Component({
    selector: 'notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationComponent implements OnInit{
    private messages: Message[] = [];

    constructor(private service: MessageService){}

    ngOnInit(): void {
        this.service.showMessage
            .subscribe(message => this.messages.push(message));

        this.service.hideMessage
            .subscribe(message => {
                this.messages = this.messages.filter(el  => el.title !== message.title);
            })
    }

    hideMessage(message:Message){
        this.service.hide(message);
    }
}


// WEBPACK FOOTER //
// ./src/app/front/core/notifications/notifications.component.ts